import '../js/vendor/jquery.fitvids';
import '../js/navigation';
import '../js/skip-link-focus-fix';

import ScrollReveal from 'scrollreveal';

(function ($) {
	'use strict';

	$('.featured-slider__carousel').slick({
		dots: getThemeMod.sliderDotNavigation ? true : false,
		arrows: getThemeMod.sliderArrowNavigation ? true : false,
		infinite: true,
		fade: getThemeMod.sliderAnimation == 'fade' ? true : false,
		speed: getThemeMod.sliderAnimationSpeed
			? parseInt(getThemeMod.sliderAnimationSpeed)
			: 500,
		autoplay: getThemeMod.sliderAutoplay ? true : false,
		autoplaySpeed: getThemeMod.sliderAutoplaySpeed
			? parseInt(getThemeMod.sliderAutoplaySpeed)
			: 5000,
		slidesToShow: 1,
		slidesToScroll: 1,
		nextArrow:
			'<button class="featured-slider__arrow button--nostyle next" aria-label="Next">' +
			icons.chevronRight +
			'</button>',
		prevArrow:
			'<button class="featured-slider__arrow button--nostyle prev" aria-label="Previous">' +
			icons.chevronLeft +
			'</button>',
	});

	// Add chevron icons to menu items with children
	$('.navigation > div > ul > li.menu-item-has-children').append(
		'<span class="sub-menu-toggle">' + icons.chevronDown + '</span>'
	);
	$('.navigation > div > ul > li > ul > li.menu-item-has-children').append(
		'<span class="sub-menu-toggle">' + icons.chevronRight + '</span>'
	);

	// Toggle submenus within the mobile navigation menu
	$('.navigation--responsive li')
		.has('ul')
		.append(
			'<button class="navigation--responsive-arrow button--nostyle" aria-expanded="false">' +
				icons.chevronDown +
				'</button>'
		);

	// Handle clicking of mobile menu dropdown button
	$('.navigation--responsive li .navigation--responsive-arrow').click(
		function () {
			// Dropdown button
			var dropDownButton = $(this);
			// Dropdown Icon
			var svg = dropDownButton.find('.icon');
			// Holds the icons 'use' element
			var svgUse = dropDownButton.find('.icon').find('use');

			if (svgUse.attr('href') == '#chevron-down') {
				dropDownButton.attr('aria-expanded', 'true');
				svgUse.attr('href', '#chevron-up');
				svgUse.attr('xlink:href', '#chevron-up');
				svg.removeClass('chevron-down');
				svg.addClass('chevron-up');
			} else {
				dropDownButton.attr('aria-expanded', 'false');
				svgUse.attr('href', '#chevron-down');
				svgUse.attr('xlink:href', '#chevron-down');
				svg.addClass('chevron-down');
				svg.removeClass('chevron-up');
			}

			// Toggle sub menus
			$(this).parent().find('ul:first').slideToggle(200);
		}
	);

	// Toggle classes required to animate the flyout sidebar and overlay.
	$('.toggle-flyout').click(function () {
		// Accessibility
		$(this).attr('aria-expanded', 'true');
		// Add class to animate
		$('.sidebar-flyout').addClass('is-active');
		$('.sidebar-flyout-overlay').addClass('is-active');
	});

	$('.toggle-search').click(function () {
		// Accessibility
		$(this).attr('aria-expanded', 'true');
		// Add class to animate
		$('.site__search').addClass('is-active');
		$('.site__search .search-field').focus();
	});

	$('.site__search-close').click(function () {
		$('.site__search').attr('aria-expanded', 'false');
		$('.site__search').removeClass('is-active');
	});

	// Close the flyout sidebar when the close icon is clicked
	$('.sidebar-flyout-close').click(function () {
		$('.toggle-flyout').attr('aria-expanded', 'false');
		$('.sidebar-flyout').removeClass('is-active');
		$('.sidebar-flyout-overlay').removeClass('is-active');
	});

	// Close the flyout sidebar when the overlay is clicked
	$('.sidebar-flyout-overlay').click(function () {
		$('.sidebar-flyout').removeClass('is-active');
		$('.sidebar-flyout-overlay').removeClass('is-active');
	});

	// Toggle comments
	$('.comments__toggle-button').click(function () {
		// Accessibility
		if ($(this).attr('aria-expanded') == 'false') {
			$(this).attr('aria-expanded', 'true');
		} else {
			$(this).attr('aria-expanded', 'false');
		}

		// Add class to animate
		$('.comments__area').toggleClass('is-active');

		if (
			$(this).find('span:first-child').html() == localize.toggleCommentsShow
		) {
			$(this).find('span:first-child').html(localize.toggleCommentsHide);
		} else {
			$(this).find('span:first-child').html(localize.toggleCommentsShow);
		}
	});

	// FitVids @link http://fitvidsjs.com/
	$(document).ready(function () {
		$('.page,.post').fitVids();
	});
})(jQuery);

// When the user scrolls the page, execute myFunction
window.onscroll = function () {
	myFunction();
};

// Get the header
var header = document.getElementById('masthead');

// Get the offset position of the navbar
var sticky = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
	if (window.pageYOffset > sticky) {
		header.classList.add('sticky');
	} else {
		header.classList.remove('sticky');
	}
}
